import { Component, OnDestroy, OnInit, } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from "@angular/platform-browser";
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Webinar } from '../../models/webinars/webinar.model';
import { ResourcesService } from '../../services/resources.service';
import { ToastsService } from '../../services/toasts.service';
import { WebinarsOnDemandService } from '../../services/webinars-on-demand.service';
import { Base } from '../base/base';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';

@Component({
  selector: 'safetydirector-webinars-on-demand-link',
  templateUrl: './webinars-on-demand-link.component.html',
  styleUrls: ['./webinars-on-demand-link.component.css']
})
export class WebinarsOnDemandLinkComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;
  public industry: string | null = null;

  private size = 10;
  public tap = 0;

  private allWebinars: Webinar[];
  private allWebinarsArray: Array<Webinar[]> = [];
  public webinars: Webinar[];
  public totalWebinarsBatch;

  public selectedWebinar: Webinar;
  public selectedWebinarUrl: SafeResourceUrl;
  public pageName = "Webinars on Demand";


  constructor(
    private webinarsOnDemandService: WebinarsOnDemandService,
    private activatedRoute: ActivatedRoute,
    private sanitized: DomSanitizer,
    private resourcesService: ResourcesService,
    private toastsService: ToastsService,
    private modalService: NgbModal,    
    private titleService: Title,
    private eventTrackingService: EventTrackingService) {
    super();
    this.titleService.setTitle(this.basePageTitle + this.pageName);
  }

  

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .subscribe(params => {
        this.industry = params.get('industry');
        this._getWebinars();
      });
  }

  private _getWebinars() {
    this.BusyA = this
      .webinarsOnDemandService
      .getWebinars(this.industry!)
      .subscribe(result => {
        this.allWebinars = result;

        let totalWebinars = this.allWebinars.length;

        if (totalWebinars > 0) {
          let start = 0;

          while (start < totalWebinars) {
            let end = start + this.size;
            this.allWebinarsArray.push(this.allWebinars.slice(start, end));
            start = end;
          }

          this.totalWebinarsBatch = this.allWebinarsArray.length;

          this.setPage();
        } else {
          this.webinars = [];
        }
      });
  }

  private setPage() {
    this.webinars = this.allWebinarsArray[this.tap];
  }

  public prevPage() {
    if (this.tap > 0) {
      this.tap--;
      this.setPage();
    }
  }

  public nextPage() {
    if (this.tap < this.totalWebinarsBatch - 1) {
      this.tap++;
      this.setPage();
    }
  }

  openModal(targetModal, webinar) {

      // track download file event
      this.eventTrackingService.trackEvent('TrackEvent', {
        'Event' : EventName.industryResourcesWebinarOnDemandLink
        ,'FileName': webinar.title
      });

    const modalRef = this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
    this.selectedWebinar = webinar;
    this.selectedWebinarUrl = this.sanitized.bypassSecurityTrustResourceUrl(webinar.url);
  }

  public downloadFile(file, fileIcon) {
    let fileName = file.blobName;

    // track download file event
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event' : EventName.webinarOnDemandDownloadFile
      ,'FileName': fileName
    });

    // Replace the file icon with a spinner, save the original icon to replace when download is complete
    let originalFileIconSrc = fileIcon.src;
    fileIcon.src = "../../assets/images/spinner.gif"
    this.BusyB = this
      .resourcesService
      .downloadWebinarFile(fileName, file.lookupId)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        // Put back the original icon
        fileIcon.src = originalFileIconSrc;
        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }
  }
}
